export enum RichTextTypeEnum {
  h1 = "h1",
  h2 = "h2",
  h3 = "h3",
  h4 = "h4",
  h5 = "h5",
  h6 = "h6",
  quote = "quote",
  ul = "ul",
  ol = "ol",
  li = "li",
  link = "link",
  label = "label",
  largeBody = "large-body",
}

export enum StatusTypeEnum {
  approved = "approved",
  rejected = "rejected",
  draft = "draft",
  published = "published",
}

export enum AdTypeEnum {
  GOOGLE = "google",
  DAILYHUNT = "dailyHunt",
  CUSTOM = "custom",
}

export type RichTextType = {
  type?: RichTextTypeEnum;
  children: {
    text: string;
    bold?: boolean;
  }[];
}[];

export type MediaType = {
  id: string;
  alt: string;
  path: string;
  caption?: string;
  captionPosition?: "top" | "bottom";
  filename: string;
  mimeType: string;
  filesize: number;
  width: number;
  height: number;
  focalX: number;
  focalY: number;
  createdAt: string;
  updatedAt: string;
  url: string;
  sizes?: {
    [key in "fullHD" | "hd" | "md" | "sd" | "ld"]: {
      url: string;
      filename: string;
      width: number;
      height: number;
    } | null;
  };
  cloudflareVideoId?: {
    [k: string]: any;
    playback: {
      hls: string;
      dash: string;
    };
  };
  hlsPlaybackUrl: string;
  duration?: string;
};

export type SocialLinkType = {
  platform: string;
  url: string;
};

export type MetaType = {
  title: {
    ml: string;
    en: string;
  };
  description?: {
    ml: string;
    en: string;
  };
  keywords?: string;
  image: {
    url?: string;
    filename?: string;
    sizes: {
      [key in "fullHD" | "hd" | "md" | "sd" | "ld"]: {
        url: string;
        filename?: string;
        width: number;
        height: number;
      } | null;
    };
  };
};

export type MessageCategoryType = "success" | "error" | "warning" | "info";

export type MessageType = {
  id: number;
  type: MessageCategoryType;
  content: string;
};

export type LexContentType = {
  root: BaseNodeType;
};

export type BaseNodeType = {
  type: string;
  children?: BaseNodeType[];
};

export type YouthFestivalType = {
  leadingDistrict: { name: string; point: number; id: string }[];
  performingSchools: {
    name: string;
    place: string;
    point: number;
    id: string;
  }[];
};

export type VisualizeSpecialData = {
  data: { name: string; point: number | string; subText?: string }[];
  title: string;
  yAxisLabel?: string;
};
